import { UnitType } from '@exodus/currency';
export const createUnitType = (ticker, decimals) => UnitType.create({
    base: 0,
    [ticker]: decimals,
});
